import { render, staticRenderFns } from "./Home3.vue?vue&type=template&id=dbf7cc1a&scoped=true"
import script from "./Home3.vue?vue&type=script&lang=js"
export * from "./Home3.vue?vue&type=script&lang=js"
import style0 from "./Home3.vue?vue&type=style&index=0&id=dbf7cc1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf7cc1a",
  null
  
)

export default component.exports